import BaseModel from './BaseModel'
import {db} from '../utilities'
import { collection } from 'firebase/firestore'

export default class RollingAverageScores extends BaseModel {
  constructor() {
    super(collection(db, 'rolling_average_scores'))
  }
}
